// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C2Xz","right":"styles_right__31HW8"};